import React from 'react';
import Page from './Common/Page';
import { Row, Col } from 'reactstrap';

function ForbiddenPage() {
    return (
        <Page centered>
            <h2>Hozzáférés megtagadva</h2>
            <Row>
                <Col>
                    <p>Nincs jogosultságod az oldal megtekintéséhez.</p>
                </Col>
            </Row>
        </Page>
    );

}

export default ForbiddenPage;
